import type { LatestDataFile, WeeklySummary } from "../market-data/types";

export async function loadLatestData(): Promise<LatestDataFile | null> {
  try {
    const response = await fetch("/data/latest.json", { cache: "no-store" });
    if (!response.ok) return null;
    return await response.json() as LatestDataFile;
  } catch {
    return null;
  }
}

export async function loadWeeklySummary(symbolId: string): Promise<WeeklySummary | null> {
  try {
    const response = await fetch(`/data/weekly/${symbolId}.json`, { cache: "no-store" });
    if (!response.ok) return null;
    return await response.json() as WeeklySummary;
  } catch {
    return null;
  }
}
